export default __webpack_public_path__ + "static/media/Ticket.967a86de.svg";